import {
  AutocompleteBalanceResponse,
  AutocompleteBalanceResponseSchema,
  AutocompleteConfigResponse,
  AutocompleteConfigResponseSchema,
  TopupResponse,
  TopupResponseSchema,
} from "@codway-dev/shared";
import { AuthService } from "./auth.service";

const API_BASE_URL = "/api";

async function authedFetch(
  path: string,
  init?: RequestInit
): Promise<Response> {
  const token = await AuthService.getShopifyToken();
  if (!token) throw new Error("No Shopify token available");
  return fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...init?.headers,
    },
  });
}

export const AutocompleteService = {
  getBalance: async (): Promise<AutocompleteBalanceResponse> => {
    const res = await authedFetch("/admin/autocomplete/balance");
    if (!res.ok) throw new Error(`Failed to load balance: ${res.statusText}`);
    return AutocompleteBalanceResponseSchema.parse(await res.json());
  },

  updateConfig: async (
    enabled: boolean
  ): Promise<AutocompleteConfigResponse> => {
    const res = await authedFetch("/admin/autocomplete/config", {
      method: "PUT",
      body: JSON.stringify({ enabled }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(
        `Failed to update config: ${(err as any).message ?? res.statusText}`
      );
    }
    return AutocompleteConfigResponseSchema.parse(await res.json());
  },

  topup: async (
    package_id: string,
    return_url: string
  ): Promise<TopupResponse> => {
    const res = await authedFetch("/admin/autocomplete/topup", {
      method: "POST",
      body: JSON.stringify({ package_id, return_url }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(
        `Failed to initiate purchase: ${(err as any).message ?? res.statusText}`
      );
    }
    return TopupResponseSchema.parse(await res.json());
  },
};
